import { IPaginatedContentResponse } from './shared.dto';

abstract class IOeDataOrganizationsDAO {
    public abstract getOrganizations(params: IOeDataOrganizationsRequestParams): Promise<IPaginatedContentResponse<IOeDataOrganizationDTO>>;
}

interface IOeDataOrganizationsRequestParams {
    page: number;
    size: number;
}

interface IOeDataOrganizationCorporateDTO {
    ticker: string;
    exchange: string;
    isin: string;
    marketCap: number;
    marketCapCurrency: string;
    sector: string;
    industry: string;
    fiscalYearEnd: string;
    irWebsite: string;
}

interface IOeDataOrganizationDTO {
    organizationId: number;
    name: string;
    shortName: string;
    organizationType: string;
    parentOrganizationName: string | null;
    hqCity: string | null;
    hqCountry: string | null;
    website: string | null;
    notes: string | null;
    createdAt: string;
    updatedAt: string;
    activeStatus: string;
    corporate: IOeDataOrganizationCorporateDTO | null;
}

export { IOeDataOrganizationsDAO, IOeDataOrganizationsRequestParams, IOeDataOrganizationCorporateDTO, IOeDataOrganizationDTO };
